// Textes de la boutique : page Shop + galerie « le jeu en vrai ».
// RÈGLE : les valeurs françaises sont le texte EXACT du site d'avant la
// traduction — on ne réécrit pas la copie en passant.
// Les textes produit (name, description, features des packs) ne sont PAS ici :
// ils viennent de la base via tp()/tpList() (voir LanguageContext).
export default {
  'shop.seo.titre': 'Boutique - Puzzles Révélation Bébé',
  'shop.seo.description':
    "Deux packs Joyful Reveal pour révéler le sexe de bébé en famille. Livraison en Belgique, France, Luxembourg, Pays-Bas, Allemagne et Espagne.",

  'shop.page.chargement': 'Chargement de la boutique...',

  // Données structurées schema.org (CollectionPage) injectées dans <head>.
  'shop.schema.nom': 'Boutique Mirum Games',
  'shop.schema.description': 'Découvrez tous nos packs Joyful Reveal',

  'shop.entete.badge': '🛍️ Notre Boutique',
  'shop.entete.titre': 'Joyful Reveal - Ours',
  'shop.entete.texte':
    'Choisissez le pack parfait pour votre moment magique. Chaque puzzle est une création spéciale pour votre famille.',

  // Aide au choix : la phrase est découpée en segments car « Essentiel » et
  // « Premium » sont en <strong> dans le JSX. seg1+seg2+seg3+seg4+seg5 = la
  // phrase complète ; les espaces de début/fin des segments sont significatifs.
  'shop.aide.titre': 'Deux packs, un seul jeu',
  'shop.aide.seg1': 'L’',
  'shop.aide.seg2': 'Essentiel',
  'shop.aide.seg3': ' si vous préparez vos questions et vos équipes vous-même. Le ',
  'shop.aide.seg4': 'Premium',
  'shop.aide.seg5':
    ' si vous voulez que tout arrive déjà prêt : les pochons, le questionnaire imprimé et l’enveloppe souvenir.',

  // Replis produit : uniquement si la base ne fournit ni description ni
  // features (ne devrait pas arriver) — ce ne sont pas des clés packs.*.
  'shop.produit.descriptionRepli':
    'Découvrez ce pack Joyful Reveal pour une Gender Reveal Party inoubliable !',
  'shop.produit.repliDuo1': '2 Boîtes de jeu',
  'shop.produit.repliDuo2': 'Pack économique',
  'shop.produit.repliDuo3': 'Idéal pour 2 fêtes',
  'shop.produit.repliFamille1': '3 Kits complets',
  'shop.produit.repliFamille2': 'Meilleur rapport qualité/prix',
  'shop.produit.repliFamille3': 'Idéal grandes familles',
  'shop.produit.repliPremium1': 'Jeu complet',
  'shop.produit.repliPremium2': 'Accessoires inclus',
  'shop.produit.repliPremium3': 'Qualité premium',
  'shop.produit.repliMixte1': 'Version Fille + Garçon',
  'shop.produit.repliMixte2': 'Idéal pour les jumeaux',
  'shop.produit.repliMixte3': 'Pack complet',
  'shop.produit.repliDefaut1': 'Boîte de jeu Gender Reveal',
  'shop.produit.repliDefaut2': 'Fabrication artisanale',
  'shop.produit.repliDefaut3': 'Livraison rapide',

  // Nom de l'article tel qu'il entre dans le panier.
  'shop.panier.nomArticle': 'Joyful Reveal - Ours - {nom}',
  'shop.panier.suffixeGarcon': ' (Garçon)',
  'shop.panier.suffixeFille': ' (Fille)',

  'shop.grille.altPhoto': '{nom} — jeu de gender reveal Joyful Reveal, photo du produit',
  'shop.grille.rupture': '❌ RUPTURE',
  'shop.grille.bientotRetour': 'Bientôt de retour',
  'shop.grille.enStock': 'En stock',
  'shop.grille.voirPlus': 'Voir plus',
  'shop.grille.autresCaracteristiques': '+{n} autres',
  'shop.grille.epuise': 'Épuisé',
  'shop.grille.ajoute': '✓ Ajouté!',
  'shop.grille.ajouter': '🛒 Ajouter',
  'shop.grille.versPanier': '→ Panier',
  'shop.grille.ficheComplete': '📋 Voir la fiche complète',

  'shop.vide.titre': 'Aucun pack trouvé',
  'shop.vide.texte': 'Essayez un autre filtre',

  'shop.pourquoi.titre': 'Pourquoi choisir Joyful Reveal?',
  'shop.pourquoi.emballageTitre': 'Emballage Premium',
  'shop.pourquoi.emballageTexte':
    'Chaque puzzle arrive dans un emballage cadeau élégant, prêt à offrir ou à découvrir ensemble.',
  'shop.pourquoi.jeuTitre': 'Jeu Interactif',
  'shop.pourquoi.jeuTexte':
    'Un concept unique qui transforme la révélation en un moment de jeu participatif avec questions-réponses amusantes.',
  'shop.pourquoi.assemblageTitre': 'Facile à Assembler',
  'shop.pourquoi.assemblageTexte':
    'Un puzzle conçu pour être assemblé facilement en famille pendant le jeu de questions-réponses.',
  'shop.pourquoi.momentTitre': 'Moment Magique',
  'shop.pourquoi.momentTexte':
    'Créez un souvenir inoubliable en révélant ensemble le sexe de bébé en famille.',
  'shop.pourquoi.expeditionTitre': 'Expédié de Belgique',
  'shop.pourquoi.expeditionTexte':
    'Départ sous 1 à 2 jours ouvrables vers la Belgique, la France et le Luxembourg. Emballage renforcé.',
  'shop.pourquoi.retractationTitre': "14 jours pour changer d'avis",
  'shop.pourquoi.retractationTexte':
    'Droit de rétractation de 14 jours après réception, comme le prévoit la loi européenne sur les achats en ligne.',

  'shop.cta.titre': 'Prêt à vivre la révélation magique?',
  'shop.cta.texte': 'Choisissez votre pack et créez un moment inoubliable avec votre famille',
  'shop.cta.bouton': '🛒 Découvrir les Packs',

  'shop.modale.titre': "C'est pour...",
  'shop.modale.sousTitre': 'Sélectionnez le sexe pour votre puzzle',
  'shop.modale.garcon': 'Garçon',
  'shop.modale.fille': 'Fille',
  'shop.modale.annuler': 'Annuler',

  'shop.galerie.titre': 'Le jeu en vrai',
  'shop.galerie.sousTitre':
    'Des photos du produit tel que vous le recevez — pas de mauvaise surprise.',
  'shop.galerie.agrandir': 'Agrandir la photo : {titre}',
  'shop.galerie.fermer': 'Fermer',
  'shop.galerie.boiteRectoTitre': 'La boîte',
  'shop.galerie.boiteRectoLegende': 'Le jeu Joyful Reveal, prêt à offrir.',
  'shop.galerie.boiteRectoAlt':
    'Boîte du jeu Joyful Reveal : deux oursons, pièce de puzzle à gratter « GIRL ou BOY ? »',
  'shop.galerie.contenuTitre': 'Ce que vous recevez',
  'shop.galerie.contenuLegende':
    'La boîte, la fiche quiz souvenir et les deux pochons d’équipe.',
  'shop.galerie.contenuAlt':
    'Contenu complet du jeu Joyful Reveal : la boîte, la fiche quiz souvenir et les deux pochons en tissu',
  'shop.galerie.pochonsTitre': 'Les deux équipes',
  'shop.galerie.pochonsLegende': 'Deux pochons en tissu pour l’Équipe 1 et l’Équipe 2.',
  'shop.galerie.pochonsAlt':
    'Les deux pochons en tissu du jeu, étiquetés Équipe 1 et Équipe 2, illustrés d’oursons',
  'shop.galerie.boiteVersoTitre': 'Comment on joue',
  'shop.galerie.boiteVersoLegende': 'Les 4 étapes du jeu, 2 à 10 joueurs, environ 20 minutes.',
  'shop.galerie.boiteVersoAlt':
    'Dos de la boîte Joyful Reveal détaillant les 4 étapes du jeu, pour 2 à 10 joueurs, 20 minutes',
};
